module.exports = "<div id=\"chart\"></div>"